import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session-service';
import { Auth } from '../services/auth';
import { take, map } from 'rxjs/operators';
import { inject } from '@angular/core';

export const guestGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(Auth);
  const sessionService = inject(SessionService);

  // If a short-lived session exists, user is authenticated -> redirect to dashboard
  const session = sessionService.getSession();
  if (session) {
    router.navigate(['/dashboard'], { replaceUrl: true });
    return false;
  }

  // Fallback: check AuthService observable once.
  return authService.isAuthenticated$().pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        try {
          // Populate a short-lived session so other guards behave consistently
          sessionService.setSessionWithTTL({ authenticated: true }, 3600);
        } catch (e) { /* ignore */ }
        router.navigate(['/dashboard'], { replaceUrl: true });
        return false;
      }
      return true;
    })
  );
};
